module.exports = " <div id=app> <div class=control> <input type=checkbox v-model=full id=full><label for=full>完整键盘</label> <span class=loading v-show=loading>正在加载音频文件...</span> </div> <div class=keyboard> <group :group=0 v-show=full></group> <group :group=1 v-show=full></group> <group :group=2></group> <group :group=3></group> <group :group=4></group> <group :group=5 v-show=full></group> <group :group=6 v-show=full></group> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 8
 ** module chunks = 2
 **/